<div class="score {{ getScoreClass() }}">
  <svg viewBox="0 0 36 36" class="circular-chart">
    <circle class="face" cx="18" cy="18" r="16.75" />
    <path class="series" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
      [attr.stroke-dasharray]="(score * 100) + ', 100'" />
  </svg>
  <figcaption>{{ getDisplayScore(score) }}</figcaption>
  <label>{{ label }}</label>
</div>
